import { useContext } from 'react';
import { AppContext, IAppContext } from './AppProvider';

export const useAppContext = (): IAppContext => {
  const appContextValue = useContext(AppContext);
  if (!appContextValue) throw Error('useAppContext hook must be used under AppProvider');
  return appContextValue;
};
